import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { IFilterUser } from '../shared.interface';

@Component({
  selector: 'app-dialog-filter-save',
  templateUrl: './dialog-filter-save.component.html',
  styleUrls: ['./dialog-filter-save.component.scss']
})
export class DialogFilterSaveComponent implements OnInit {
  filter_title: string;
  filter_shared: boolean = false;

  filters_user: IFilterUser[];
  filter_dublicate_name: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogFilterSaveComponent>,
  @Inject(MAT_DIALOG_DATA) public data: { filters_user: IFilterUser[] }) {
    this.filters_user = data.filters_user;
  }

  ngOnInit() {
  }

  save(){
    this.dialogRef.close({title: this.filter_title, shared: this.filter_shared});
  }

  check_name(){
    this.filter_dublicate_name = (this.filters_user.filter(filter => 
    (filter.title.toUpperCase() == this.filter_title.toUpperCase())).length > 0);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-filter-save/dialog-filter-save.component.ts